import { APP_URL, CURRENT_TAG } from '@shared/config/raw-env'

export enum RequestKeyWebComponent {
  IMPORT = 'api-web-component-import',
}

const tagPrefix = CURRENT_TAG ? `${CURRENT_TAG}/` : ''

const proxyScriptUrl = `${APP_URL}/${tagPrefix}proxy.js`

export const importMap = {
  imports: {
    ...JSON.parse(import.meta.env.APP_IMPORT_MAP!),
    '@wippy-fe/proxy': `${APP_URL}/${tagPrefix}@wippy-fe/proxy.js`,
    '@wippy-fe/markdown-iframe': `${APP_URL}/${tagPrefix}@wippy-fe/markdown-iframe.js`,
  },
}

export const scripts = [
  `${APP_URL}/${tagPrefix}@wippy-fe/loading.js`,
  proxyScriptUrl,
]

/**
 * Replace hardcoded references to the deprecated front.wippy.ai domain
 * with the current proxy URL.
 */
const DEPRECATED_PROXY_URL_PATTERN = /https?:\/\/front\.wippy\.ai\/(?:[^/"'\s]*\/)?proxy\.js/g

export function replaceProxyUrls(html: string): string {
  return html.replace(DEPRECATED_PROXY_URL_PATTERN, proxyScriptUrl)
}
